type OptInOrderDocumentAccessInfoAlertProps = {
  documentLabel: string;
};

/** Shared access instructions for opt-in order document settings pages. */
export const OptInOrderDocumentAccessInfoAlert = ({ documentLabel }: OptInOrderDocumentAccessInfoAlertProps) => (
  <>
    Enable <em>{documentLabel}</em> under Settings → Documents → Document options. On a sales order (draft through delivered), open{" "}
    <strong>Create Document</strong> → <em>{documentLabel}</em>. Settings below are org-wide defaults for that form and PDF.
  </>
);
